<template>
  <div
    class="relative uk-visible-toggle"
    :class="slideshowClass"
    tabindex="-1"
    :uk-slideshow="slideshowOptions"
  >
    <ul class="uk-slideshow-items flex flex-wrap" ref="items">
      <li v-for="(item, index) in doc.items" :key="index" class="w-full">
        <asset
          :url="item.image"
          w="1920"
          h="1080"
          fit="crop_focal"
          uk-cover=""
        />

        <div
          v-if="item.overlay_opacity"
          class="overlay"
          :style="'opacity:' + item.overlay_opacity / 100"
        ></div>

        <div class="absolute top-0 left-0 w-full h-full flex items-center">
          <div class="container mx-auto text-center">
            <heading
              class="uppercase text-strong font-key-virtue ms-3 s:ms-5 lg:ms-7 tracking-wide"
              :field="item.heading"
            />
            <p class="ms-2 text-light strong font-underland" v-if="item.text">
              {{ item.text }}
            </p>
          </div>
        </div>
      </li>
    </ul>

    <a
      class="absolute left-0 top-1/2 transform -translate-y-1/2 p-2 m-3"
      href="#"
      uk-slideshow-item="previous"
    >
      <i class="las la-long-arrow-alt-left strong text-4xl"></i>
    </a>
    <a
      class="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 m-3"
      href="#"
      uk-slideshow-item="next"
    >
      <i class="las la-long-arrow-alt-right strong text-4xl"></i>
    </a>

    <ul
      class="uk-slideshow-nav dotnav absolute bottom-0 p-8 flex flex justify-center w-full"
    ></ul>
  </div>
</template>

<script>
export default {
  props: ["doc"],

  computed: {
    slideshowOptions() {
      var options = "min-height: 400; autoplay: true; ";

      options += {
        large: "ratio: 7:3",
        small: "ratio: 3:1",
        screen: "ratio: false"
      }[this.doc.height];

      return options;
    },
    slideshowClass() {
      var className = {
        screen: "fill-section",
        page: "container mx-auto"
      }[this.doc.width];

      className += {
        dark: " inverse"
      }[this.doc.color];

      return className;
    }
  },

  mounted() {
    if (this.doc.height == "screen") {
      UIkit.heightViewport(this.$refs.items, {
        offset: true
      });
    }
  },

  created() {
    console.log("Slideshow");
    console.log(this);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Slideshow.vue